export class CloseLeadInput {
  leadId: string;
  comments: string;
  closeDate: Date;
  comingFromCallModal: boolean;
}
